import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutModule } from '@angular/cdk/layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PapaParseModule } from 'ngx-papaparse'
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ClipboardModule } from 'ngx-clipboard';
import { ImageCropperModule } from 'ngx-image-cropper';
// import { NgSelectModule } from '@ng-select/ng-select';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SchedulerModalComponent } from './scheduler-modal/scheduler-modal.component';


import {
  MatToolbarModule,
  MatCardModule,
  MatButtonModule,
  MatSidenavModule,
  MatIconModule,
  MatListModule,
  MatCheckboxModule,
  MatRippleModule,
  MatButtonToggleModule,
  MatSnackBarModule,
  MatDialogModule,
  MatPaginatorModule,
  MatTabsModule,
  MatFormFieldModule,
  MatStepperModule,
  MatSelectModule,
  MatTableModule,
  MatRadioModule,
  MatTooltipModule,
  MatSlideToggleModule,
  MatBadgeModule,
  MatChipsModule,
  MatExpansionModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatInputModule,
  MatProgressBarModule,
  MatAutocompleteModule
} from '@angular/material';
import { MatMenuModule } from '@angular/material/menu';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardVendorComponent } from './dashboard-vendor/dashboard-vendor.component';
import { PagesComponent } from './pages.component';
import { PageRoutingModule } from './pages.routing';
import { MainNavComponent } from '../main-nav/main-nav.component';

// User Page
import { UsersComponent } from './users/users.component';
import { UserCreateModalComponent } from './users/user-create-modal/user-create-modal.component';
import { PermissionModalComponent } from './users/permission-modal/permission-modal.component';

// Project Pages
import { ClientProjectComponent } from './client-project/client-project.component';
import { ClientProjectCreateModalComponent } from './client-project/client-project-create-modal/client-project-create-modal.component';
import { ClientProjectEditModalComponent } from './client-project/client-project-edit-modal/client-project-edit-modal.component';
import { ClientProjectDeleteModalComponent } from './client-project/client-project-delete-modal/client-project-delete-modal.component';
import { ClientProjectInfoModalComponent } from './client-project/client-project-info-modal/client-project-info-modal.component';
import { ClientProjectBrochuerModalComponent } from './client-project/client-project-brochuer-modal/client-project-brochuer-modal.component';
import { ProjectStatusModalComponent } from './client-project/project-status-modal/project-status-modal.component';
import { DeleteProjectStatusModalComponent } from './client-project/delete-project-status-modal/delete-project-status-modal.component';



// Permission
import { PermissionComponent } from './configuration/permission/permission.component';
import { PermissionAddModalComponent } from './configuration/permission/permission-add-modal/permission-add-modal.component';

// Color
import { ColorComponent } from './configuration/color/color.component';
import { ColorCreateModalComponent } from './configuration/color/color-create-modal/color-create-modal.component';
import { ColorDeleteModalComponent } from './configuration/color/color-delete-modal/color-delete-modal.component';
import { ColorEditModalComponent } from './configuration/color/color-edit-modal/color-edit-modal.component';

// Client Leads
import { ClientLeadComponent } from './client-lead/client-lead.component';
import { ClientRemarkModalComponent } from './client-lead/client-remark-modal/client-remark-modal.component';
import { ClientLeadCreateModalComponent } from './client-lead/client-lead-create-modal/client-lead-create-modal.component';
import { ClientLeadEditModalComponent } from './client-lead/client-lead-edit-modal/client-lead-edit-modal.component';
import { ClientLeadFilterModalComponent } from './client-lead/client-lead-filter-modal/client-lead-filter-modal.component';
import { ClientLeadInfoModalComponent } from './client-lead/client-lead-info-modal/client-lead-info-modal.component';
import { ClientUploadModalComponent } from './client-lead/client-upload-modal/client-upload-modal.component';
import { ClientExportLeadModalComponent } from './client-lead/client-export-lead-modal/client-export-lead-modal.component';
import { ClientLeadDeleteModalComponent } from './client-lead/client-lead-delete-modal/client-lead-delete-modal.component';
import { ClientLeadWebhookCreateModalComponent } from './client-lead/client-lead-webhook-create-modal/client-lead-webhook-create-modal.component';
import { ClientAssignLeadModalComponent } from './client-lead/client-assign-lead-modal/client-assign-lead-modal.component';
import { ClientLeadTransferModalComponent } from './client-lead/client-lead-transfer-modal/client-lead-transfer-modal.component';
import { ClientWebhookDeleteModalComponent } from './client-lead/client-webhook-delete-modal/client-webhook-delete-modal.component'
import { CreateMeetingModalComponent } from './client-lead/create-meeting-modal/create-meeting-modal.component'
// Client Lead Profile Pages
import { ClientLeadProfileComponent } from './client-lead-profile/client-lead-profile.component';
import { ClientLeadProfileTaskCreateModalComponent } from './client-lead-profile/client-lead-profile-task-create-modal/client-lead-profile-task-create-modal.component';
import { ClientLeadProfileNoteCreateModalComponent } from './client-lead-profile/client-lead-profile-note-create-modal/client-lead-profile-note-create-modal.component';
import { ClientLeadAddressCreateModalComponent } from './client-lead-profile/client-lead-address-create-modal/client-lead-address-create-modal.component';
import { ClientLeadAddressEditModalComponent } from './client-lead-profile/client-lead-address-edit-modal/client-lead-address-edit-modal.component';
import { ClientLeadEmailCreateModalComponent } from './client-lead-profile/client-lead-email-create-modal/client-lead-email-create-modal.component';
import { ClientLeadAttachmentCreateModalComponent } from './client-lead-profile/client-lead-attachment-create-modal/client-lead-attachment-create-modal.component';
import { ClientLeadProfileEditModalComponent } from './client-lead-profile/client-lead-profile-task-edit-modal/client-lead-profile-task-edit-modal.component';
import { ClientLeadProfileNoteEditModalComponent } from './client-lead-profile/client-lead-profile-note-edit-modal/client-lead-profile-note-edit-modal.component';
import { ClientTaskMarkDoneModalComponent } from './client-lead-profile/client-task-mark-done-modal/client-task-mark-done-modal.component';
import { ClientTaskDeleteModalComponent } from './client-lead-profile/client-task-delete-modal/client-task-delete-modal.component';
import { ClientNoteDeleteModalComponent } from './client-lead-profile/client-note-delete-modal/client-note-delete-modal.component';
import { ClientAddressDeleteModalComponent } from './client-lead-profile/client-address-delete-modal/client-address-delete-modal.component';
import { ClientDocumentDeleteModalComponent } from './client-lead-profile/client-document-delete-modal/client-document-delete-modal.component';
import { ClientEditProfileModalComponent } from './client-lead-profile/client-edit-profile-modal/client-edit-profile-modal.component';
import { PreviewNumberModalComponent } from './client-lead/preview-number-modal/preview-number-modal.component';

// CLient Rule assignmengt
import { ClientRuleAssignmentComponent } from './client-rule-assignment/client-rule-assignment.component';
import { ClientRuleAssignmentCreateModalComponent } from './client-rule-assignment/client-rule-assignment-create-modal/client-rule-assignment-create-modal.component';
import { ClientRuleEntryModalComponent } from './client-rule-assignment/client-rule-entry-modal/client-rule-entry-modal.component';
import { ClientCreateRuleEntryModalComponent } from './client-rule-assignment/client-create-rule-entry-modal/client-create-rule-entry-modal.component';
import { ClientEditRuleEntryModalComponent } from './client-rule-assignment/client-edit-rule-entry-modal/client-edit-rule-entry-modal.component';
import { ClientAssignmentDeleteModalComponent } from './client-rule-assignment/client-assignment-delete-modal/client-assignment-delete-modal.component';
import { ClientRuleEntryDeleteModalComponent } from './client-rule-assignment/client-rule-entry-delete-modal/client-rule-entry-delete-modal.component';

//Whatsapp Rule

import { CreateWhatsappRulesComponent } from './create-whatsapp-rules/create-whatsapp-rules.component';
import { WhatsappRuleEntryComponent } from './whatsapp-rule-entry/whatsapp-rule-entry.component';
import { EditWhatsappRuleEntryComponent } from './edit-whatsapp-rule-entry/edit-whatsapp-rule-entry.component';

///

import { HighchartsChartModule } from 'highcharts-angular';
import { FlexLayoutModule } from '@angular/flex-layout'
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgxTinymceModule } from 'ngx-tinymce'

import { ClientLeadFailedModalComponent } from './client-lead/client-lead-failed-modal/client-lead-failed-modal.component';
import { ClientMasterLeadComponent } from './client-master-lead/client-master-lead.component';
import { LeadUpdatedToVerifiedStatusModalComponent } from './client-master-lead/lead-updated-to-verified-status-modal/lead-updated-to-verified-status-modal.component'
import { UserInfoModalComponent } from './users/user-info-modal/user-info-modal.component';

import { ClientListComponent } from './client-list/client-list.component';
import { CustomizePolicyComponent } from './configuration/customize-policy/customize-policy.component';
import { CustomizePolicyAddModalComponent } from './configuration/customize-policy/customize-policy-add-modal/customize-policy-add-modal.component';
import { CustomizePolicyModalInfoComponent } from './configuration/customize-policy/customize-policy-modal-info/customize-policy-modal-info.component';
import { UserTokenComponent } from './users/user-token/user-token.component';
import { UserAssignProjectComponent } from './users/user-assign-project/user-assign-project.component';
import { ClientCreateModalComponent } from './client-list/client-create-modal/client-create-modal.component';
import { ClientInfoModalComponent } from './client-list/client-info-modal/client-info-modal.component';
import { VendorAssignModelComponent } from './client-list/vendor-assign-model/vendor-assign-model.component';
import { ClientEditModalComponent } from './client-list/client-edit-modal/client-edit-modal.component';
import { ProjectEmailNotifyModalComponent } from './client-project/project-email-notify-modal/project-email-notify-modal.component';
import { RegistrationCreateModalComponent } from './registration-list/registration-create-modal/registration-create-modal.component';
import { RegistrationListComponent } from './registration-list/registration-list.component';
import { RegistrationFilterModalComponent } from './registration-list/registration-filter-modal/registration-filter-modal.component';
import { LeadListModalComponent } from './dashboard/lead-list-modal/lead-list-modal.component';
import { ProjectUploadAvatarModalComponent } from './client-project/project-upload-avatar-modal/project-upload-avatar-modal.component';
import { ClientProjectQualifiedModalComponent } from './client-project/client-project-qualified-modal/client-project-qualified-modal.component';
import { ProjectFeedbackModalComponent } from './client-project/project-feedback-modal/project-feedback-modal.component';

import { CampaignListComponent } from './campaign/campaign-list.component'
import { CampaignCreateModalComponent } from './campaign/campaign-create-modal/campaign-create-modal.component';
import { CopyLeadModalComponent } from './client-lead/copy-lead-modal/copy-lead-modal.component';
import { SetLeadColorModalComponent } from './client-lead/set-lead-color-modal/set-lead-color-modal.component';
import { AppointmentModalComponent } from './client-lead/appointment-modal/appointment-modal.component';
import { LeadVndorUpdatedModalComponent } from './client-master-lead/lead-vendor-updated-modal/lead-vendor-updated-modal.component';
import { ConfirmLeadModalComponent } from './client-lead/confirm-lead-modal/confirm-lead-modal.component';
import { CallsListModalComponent } from './client-lead/calls-list-modal/calls-list-modal.component';
import { CopyMultipleLeadModalComponent } from './client-lead/copy-multiple-lead-modal/copy-multiple-lead-modal.component';
import { AdminProjectModalComponent } from './client-lead/admin-project-modal/admin-project-modal.component';
import { AdminClientProjectModalComponent } from './client-lead/admin-client-project-modal/admin-client-project-modal.component';
import { MakeCallComponent } from './client-lead/make-call/make-call.component';
import { DashboardFilterModalComponent } from './dashboard-vendor/dashboard-filter-modal/dashboard-filter-modal.component';
import { VendorLogsComponent } from './vendor-logs/vendor-logs.component';
import { VendorLogsFilterModalComponent } from './vendor-logs/vendor-logs-filter-modal/vendor-logs-filter-modal.component';
import { AuditLogInfoComponent } from './vendor-logs/audit-log-info/audit-log-info.component';
import { VendorListComponent } from './vendor-list/vendor-list.component';
import { VendorCreateModalComponent } from './vendor-list/vendor-create-modal/vendor-create-modal.component';
import { VendorEditModalComponent } from './vendor-list/vendor-edit-modal/vendor-edit-modal.component';
import { VendorInfoModalComponent } from './vendor-list/vendor-info-modal/vendor-info-modal.component';
import { ClientAssignModelComponent } from './vendor-list/client-assign-model/client-assign-model.component';
import { UserEditModalComponent } from './users/user-edit-modal/user-edit-modal.component';
import { UserProfileModalComponent } from './users/user-profile-modal/user-profile-modal.component';
import { CallReportComponent } from './call-report/call-report.component';
import { LeadReportComponent } from './lead-report/lead-report.component';
import { LeadReportDeleteModalComponent } from './lead-report/lead-report-delete-modal/lead-report-delete-modal.component';
import { CreateLeadReportComponent } from './lead-report/create-report/create-report.component';

import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { EditLeadReportComponent } from './lead-report/edit-report/edit-report.component';
import { UserFilterModalComponent } from './users/user-filter-modal/user-filter-modal.component';
import { ProjectFilterModalComponent } from './client-project/project-filter-modal/project-filter-modal.component';
import { ClientFilterModalComponent } from './client-list/client-filter-modal/client-filter-modal.component';
import { VendorFilterModalComponent } from './vendor-list/vendor-filter-modal/vendor-filter-modal.component';
import { WebhookByProjectComponent } from './client-lead/webhook-by-project/webhook-by-project.component';
import { WebhookCopyComponent } from './client-lead/webhook-copy/webhook-copy.component';
import { LeadDuplicateInfoComponent } from './client-lead/lead-duplicate-info/lead-duplicate-info.component';
import { ProjectInsightComponent } from './project-insight/project-insight.component';
import { LeadRequestComponent } from './lead-request/lead-request.component';
import { ClientProjectStatsModalComponent } from './client-project/client-project-stats-modal/client-project-stats-modal.component';
import { PersonaComponent } from './persona/persona.component';

// booking
import { BookingsComponent } from './bookings/bookings.component';
import { CreateBookingModalComponent } from './bookings/create-booking-modal/create-booking-modal.component';
import { DeleteBookingModalComponent } from './bookings/delete-booking-modal/delete-booking-modal.component';
import { BookingFilterModalComponent } from './bookings/booking-filter-modal/booking-filter-modal.component';
import { LeadSendMiModalComponent } from './client-project/lead-send-mi-modal/lead-send-mi-modal.component';
import { ProjectMediaPlanComponent } from './client-project/project-media-plan/project-media-plan.component';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { WhatsappProfileModalComponent } from './whatsapp-profile-modal/whatsapp-profile-modal.component';
import { ClientListProjectModalComponent } from './client-list/client-list-project-modal/client-list-project-modal.component';
import { WhatsappRulesComponent } from './whatsapp-rules/whatsapp-rules.component';
import { CreateWhatsappRuleEntryComponent } from './create-whatsapp-rule-entry/create-whatsapp-rule-entry.component';

// Sales Account

import { SalesAccountComponent } from './sales-account/sales-account.component';
import { SalesAccountCreateModalComponent } from './sales-account/sales-account-create-modal/sales-account-create-modal.component';
import { AssignUserComponent } from './sales-account/assign-user/assign-user.component';
import { AssignProjectComponent } from './sales-account/assign-project/assign-project.component';


//Call Logs

import { CallLogsComponent } from './call-logs/call-logs.component';
import { UserListModalComponent } from './client-project/user-list-modal/user-list-modal.component';
import { CallLogsFilterModalComponent } from './call-logs/call-logs-filter-modal/call-logs-filter-modal.component';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ProjectAllStatusModalComponent } from './client-project/project-all-status-modal/project-all-status-modal.component';
// import { SchedulerModalComponent } from './scheduler-modal/scheduler-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ClientProjectCloneComponent } from './client-project/client-project-clone/client-project-clone.component';
import { ProjectByClientComponent } from './client-project/project-by-client/project-by-client.component';
import { StatsBashboardComponent } from './stats-bashboard/stats-bashboard.component';
import { WebdatarocksPivotModule } from 'ng-webdatarocks';
import { ClientProjectWhatsappProfileDeleteComponent } from './client-project/client-project-whatsapp-profile-delete/client-project-whatsapp-profile-delete.component';
import { CallerNumberModalComponent } from './client-lead/caller-number-modal/caller-number-modal.component';
import { ValidateLeadPhoneComponent } from './client-lead/validate-lead-phone/validate-lead-phone.component';
import { IvrCallDashboardComponent } from './ivr-call/ivr-call-dashboard/ivr-call-dashboard.component';
import { PrjectWiseCallDashboardComponent } from './ivr-call/prject-wise-call-dashboard/prject-wise-call-dashboard.component';
import { TelecallerWiseCallDashboardComponent } from './ivr-call/telecaller-wise-call-dashboard/telecaller-wise-call-dashboard.component';
import { ClientWiseCallDashboardComponent } from './ivr-call/client-wise-call-dashboard/client-wise-call-dashboard.component';
import { ProjectWiseCallDashboardTwoComponent } from './ivr-call/project-wise-call-dashboard-two/project-wise-call-dashboard-two.component';
import { ExportCallRecordingComponent } from './client-lead/export-call-recording/export-call-recording.component';
import { ProjectWiseSourceDashboardComponent } from './ivr-call/project-wise-source-dashboard/project-wise-source-dashboard.component';
import { ClientLeadFeedbackUpdateComponent } from './client-lead/client-lead-feedback-update/client-lead-feedback-update.component';
import { TasksComponent } from './tasks/tasks.component';
import { FilterTaskComponent } from './tasks/filter-task/filter-task.component';
import { LeadListUModalComponent } from './dashboard/lead-list-u-modal/lead-list-u-modal.component';
import { EnrichFilterComponent } from './client-lead/enrich-filter/enrich-filter.component';
import { SuccessfulResetComponent } from './users/successful-reset/successful-reset.component';
// import { EnrichFilterComponent } from './client-lead/enrich-filter/enrich-filter.component';
import { ResetPasswordComponent } from './users/reset-password/reset-password.component';
import { SequentialCallingComponent } from './client-lead/sequential-calling/sequential-calling.component';
import { SaleCampaignComponent } from './campaign-dir/sale-campaign/sale-campaign.component';
import { CampaignDetailsComponent } from './campaign/campaign-details/campaign-details.component';
import { CampaignFilterModalComponent } from './campaign-dir/campaign-filter-modal/campaign-filter-modal.component';
import { SaleCampaignCreateModalComponent } from './campaign-dir/sale-campaign-create-modal/sale-campaign-create-modal.component';
import { SaleCampaignEditModalComponent } from './campaign-dir/sale-campaign-edit-modal/sale-campaign-edit-modal.component';
import { SaleCampaignClientCreateModalComponent } from './campaign-dir/sale-campaign-client-create-modal/sale-campaign-client-create-modal.component';

// import { WebdatarocksPivotModule } from 'ng-webdatarocks';


import { QuillModule } from 'ngx-quill';
import { AssignUserToCampaignComponent } from './campaign/assign-user-to-campaign/assign-user-to-campaign.component';
import { CampaignLinksComponent } from './campaign/campaign-links/campaign-links.component';
import { CampaignAttachmentsComponent } from './campaign/campaign-attachments/campaign-attachments.component';
import { SaleCampaignProjectCreateModalComponent } from './campaign-dir/sale-campaign-project-create-modal/sale-campaign-project-create-modal.component';
import { TaskStatusRemarkModalComponent } from './campaign/task-status-remark-modal/task-status-remark-modal.component';
import { CreateCampaignTaskComponent } from './campaign/create-campaign-task/create-campaign-task.component';
import { CampaignCommentComponent } from './campaign/campaign-comment/campaign-comment.component';
import { CampaignStatusComponent } from './campaign/campaign-status/campaign-status.component';
import { AddLeadDeliveredComponent } from './campaign-dir/add-lead-delivered/add-lead-delivered.component';

import { MatGridListModule } from '@angular/material/grid-list';
import { AddBudgetComponent } from './campaign-dir/add-budget/add-budget.component';
import { AddAmountSpentComponent } from './campaign-dir/add-amount-spent/add-amount-spent.component';
import { LeadDeliveryListComponent } from './campaign-dir/lead-delivery-list/lead-delivery-list.component';
import { AmountSpentListComponent } from './campaign-dir/amount-spent-list/amount-spent-list.component';
import { BudgetListComponent } from './campaign-dir/budget-list/budget-list.component';
import { AddFeedbackComponent } from './campaign-dir/add-feedback/add-feedback.component';
import { FeedbackListModalComponent } from './campaign-dir/feedback-list-modal/feedback-list-modal.component';
import { RaiseEscalationComponent } from './campaign-dir/raise-escalation/raise-escalation.component';
import { EscalationStatusModalComponent } from './campaign-dir/escalation-status-modal/escalation-status-modal.component';
import { EscalationListComponent } from './escalation/escalation-list/escalation-list.component';
import { CreateCreativeJobComponent } from './campaign/create-creative-job/create-creative-job.component';
import { WordSortPipe } from '../pipe/word-sort.pipe';
import { EscalationFilterModalComponent } from './escalation/escalation-filter-modal/escalation-filter-modal.component';
import { CreatePresalesJobComponent } from './campaign/create-presales-job/create-presales-job.component';
import { CampaignJobLinksComponent } from './campaign/campaign-job-links/campaign-job-links.component';
import { AssignUserToJobsComponent } from './campaign/assign-user-to-jobs/assign-user-to-jobs.component';
import { CampaignJobAttachmentsComponent } from './campaign/campaign-job-attachments/campaign-job-attachments.component';
import { PresalesDoneStatusComponent } from './campaign/presales-done-status/presales-done-status.component';
import { CampaignProjectsComponent } from './campaign/campaign-projects/campaign-projects.component';
import { AscalationCommentModalComponent } from './escalation/ascalation-comment-modal/ascalation-comment-modal.component';
import { CreativeMasterComponent } from './creative-master/creative-master.component';
import { CreativeMasterFilterModalComponent } from './creative-master/creative-master-filter-modal/creative-master-filter-modal.component';
import { CreativeMasterCommentModalComponent } from './creative-master/creative-master-comment-modal/creative-master-comment-modal.component';
import { PresaleJobListComponent } from './pre-sale-job-master/presale-job-list/presale-job-list.component';
import { PresaleCommentModalComponent } from './pre-sale-job-master/presale-comment-modal/presale-comment-modal.component';
import { PresaleMasterFilterComponent } from './pre-sale-job-master/presale-master-filter/presale-master-filter.component';
import { ViewTaskDetailsComponent } from './campaign/view-task-details/view-task-details.component';
import { AssignClientToCampaignComponent } from './campaign/assign-client-to-campaign/assign-client-to-campaign.component';
import { CreateMarketingJobComponent } from './campaign/create-marketing-job/create-marketing-job.component';
import { MarketingJobListComponent } from './marketing-job-master/marketing-job-list/marketing-job-list.component';
import { MarketingJobFilterModalComponent } from './marketing-job-master/marketing-job-filter-modal/marketing-job-filter-modal.component';
import { MarketingJobCommentModalComponent } from './marketing-job-master/marketing-job-comment-modal/marketing-job-comment-modal.component';
import { ProjectListModalComponent } from './campaign-dir/project-list-modal/project-list-modal.component';
import { DeleteAttachmentComponent } from './campaign/delete-attachment/delete-attachment.component';
import { DrrMasterListComponent } from './DRR-master/drr-master-list/drr-master-list.component';
import { DrrFilterMasterModalComponent } from './DRR-master/drr-filter-master-modal/drr-filter-master-modal.component';
import { DeleteAttachmentJobComponent } from './campaign/delete-attachment-job/delete-attachment-job.component';
import { StrtoarrayPipe } from '../pipe/strtoarray.pipe';
import { DeleteLinkComponent } from './campaign/delete-link/delete-link.component';
import { DeleteLinkJobComponent } from './campaign/delete-link-job/delete-link-job.component';
import { DeleteSpendBudgetFeebackLeaddeliveryComponent } from './campaign-dir/delete-spend-budget-feeback-leaddelivery/delete-spend-budget-feeback-leaddelivery.component';
import { CreateCampaignReviewComponent } from './campaign/create-campaign-review/create-campaign-review.component';
import { CreateCampaignReviewActionItemComponent } from './campaign/create-campaign-review-action-item/create-campaign-review-action-item.component';
import { UpdateCampaignReviewActionItemComponent } from './campaign/update-campaign-review-action-item/update-campaign-review-action-item.component';
import { CancelledStatusModalComponent } from './campaign/cancelled-status-modal/cancelled-status-modal.component';
import { ReviewMasterComponent } from './review-master/review-master.component';
import { ActionItemsComponent } from './review-master/action-items/action-items.component';
import { ListingPresalesProgressLogComponent } from './campaign/listing-presales-progress-log/listing-presales-progress-log.component';
import { CreatePresalesProgressLogComponent } from './campaign/create-presales-progress-log/create-presales-progress-log.component';
import { DeletePresalesLogComponent } from './campaign/delete-presales-log/delete-presales-log.component';
import { AmountSpentBulkEntryComponent } from './campaign-dir/amount-spent-bulk-entry/amount-spent-bulk-entry.component';
import { LeadDeliveryBulkEntryComponent } from './campaign-dir/lead-delivery-bulk-entry/lead-delivery-bulk-entry.component';
import { MakeCallCloneComponent } from './client-lead/make-call-clone/make-call-clone.component';
import { CampaignReChurnsProjectsComponent } from './campaign/campaign-re-churns-projects/campaign-re-churns-projects.component';
import { MediaPlanComponent } from './media-plan/media-plan.component';
import { MediaPlanRequestCommentComponent } from './media-plan/media-plan-request-comment/media-plan-request-comment.component';
import { CreateMediaPlanRequestComponent } from './media-plan/create-media-plan-request/create-media-plan-request.component';
import { CreateMediaPlanComponent } from './media-plan/create-media-plan/create-media-plan.component';
import { ViewMediaPlanComponent } from './media-plan/view-media-plan/view-media-plan.component';
import { ViewMediaPlanRequestComponent } from './media-plan/view-media-plan-request/view-media-plan-request.component';
import { CancelledStatusComponent } from './media-plan/cancelled-status/cancelled-status.component';
import { EditMediaPlanRequestComponent } from './media-plan/edit-media-plan-request/edit-media-plan-request.component';
import { EditMediaPlanComponent } from './media-plan/edit-media-plan/edit-media-plan.component';
import { ClientLeadWebhookEditModalComponent } from './client-lead/client-lead-webhook-edit-modal/client-lead-webhook-edit-modal.component';
import { ClientLeadWebhookDeleteRemarkModalComponent } from './client-lead/client-lead-webhook-delete-remark-modal/client-lead-webhook-delete-remark-modal.component';
import { CommentMasterComponent } from './comment-master/comment-master.component';
import { CampaignMetaComponent } from './campaign/campaign-meta/campaign-meta.component';
import { ClientNotificationComponent } from './client-project/client-notification/client-notification.component';
import { ClientParticipantComponent } from './review-master/client-participant/client-participant.component';
import { EscalationResultComponent } from './escalation/escalation-result/escalation-result.component';
import { EscalationActionItemComponent } from './escalation/escalation-action-item/escalation-action-item.component';
import { EscalationFeedbackViewComponent } from './escalation/escalation-feedback-view/escalation-feedback-view.component';
import { ViewEscalationComponent } from './escalation/view-escalation/view-escalation.component';
import { CampaignReportComponent } from './campaign-report/campaign-report.component';



// import { MatTooltipModule } from '@angular/material/tooltip';
// import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    DashboardComponent,
    LeadListModalComponent,
    LeadListUModalComponent,
    DashboardVendorComponent,
    DashboardFilterModalComponent,
    MainNavComponent,
    PagesComponent,
    SchedulerModalComponent,

    // User Component
    UsersComponent,
    StatsBashboardComponent,
    UserCreateModalComponent,
    UserInfoModalComponent,
    UserAssignProjectComponent,
    UserTokenComponent,
    PermissionModalComponent,
    UserEditModalComponent,
    UserProfileModalComponent,
    UserFilterModalComponent,

    // Permission Configuration Component
    PermissionComponent,
    PermissionAddModalComponent,

    CampaignListComponent,
    CampaignCreateModalComponent,

    // Color Configuration Component
    ColorComponent,
    ColorCreateModalComponent,
    ColorDeleteModalComponent,
    ColorEditModalComponent,

    // Color Configuration Component
    CustomizePolicyComponent,
    CustomizePolicyAddModalComponent,
    CustomizePolicyModalInfoComponent,

    // Client List
    ClientListComponent,
    VendorAssignModelComponent,
    ClientCreateModalComponent,
    ClientEditModalComponent,
    ClientInfoModalComponent,
    ClientFilterModalComponent,

    // Client Project Component
    ClientProjectComponent,
    ClientProjectCreateModalComponent,
    ClientProjectDeleteModalComponent,
    ClientProjectEditModalComponent,
    ClientProjectInfoModalComponent,
    ClientProjectBrochuerModalComponent,
    ProjectEmailNotifyModalComponent,
    ProjectUploadAvatarModalComponent,
    ClientProjectQualifiedModalComponent,
    ProjectFeedbackModalComponent,
    ProjectFilterModalComponent,
    ClientProjectStatsModalComponent,
    ProjectStatusModalComponent,
    DeleteProjectStatusModalComponent,
    ClientProjectInfoModalComponent,
    // Client Lead Component
    ClientMasterLeadComponent,
    ClientLeadComponent,
    ClientLeadCreateModalComponent,
    ClientLeadEditModalComponent,
    ClientLeadFilterModalComponent,
    ClientLeadInfoModalComponent,
    ClientRemarkModalComponent,
    ClientUploadModalComponent,
    ClientExportLeadModalComponent,
    ClientLeadDeleteModalComponent,
    ClientAssignLeadModalComponent,
    ClientLeadWebhookCreateModalComponent,
    ClientLeadTransferModalComponent,
    ClientLeadFailedModalComponent,
    ClientWebhookDeleteModalComponent,
    CopyLeadModalComponent,
    SetLeadColorModalComponent,
    AppointmentModalComponent,
    ConfirmLeadModalComponent,
    LeadVndorUpdatedModalComponent,
    CallsListModalComponent,
    CopyMultipleLeadModalComponent,
    AdminProjectModalComponent,
    AdminClientProjectModalComponent,
    MakeCallComponent,
    WebhookCopyComponent,
    WebhookByProjectComponent,
    LeadUpdatedToVerifiedStatusModalComponent,
    LeadDuplicateInfoComponent,
    CreateMeetingModalComponent,

    // Client Lead Profile Component
    ClientLeadProfileComponent,
    ClientLeadProfileTaskCreateModalComponent,
    ClientLeadProfileEditModalComponent,
    ClientTaskMarkDoneModalComponent,
    ClientLeadProfileNoteCreateModalComponent,
    ClientLeadProfileNoteEditModalComponent,
    ClientLeadAddressEditModalComponent,
    ClientLeadAddressCreateModalComponent,
    ClientLeadEmailCreateModalComponent,
    ClientLeadAttachmentCreateModalComponent,
    ClientTaskDeleteModalComponent,
    ClientNoteDeleteModalComponent,
    ClientAddressDeleteModalComponent,
    ClientDocumentDeleteModalComponent,
    ClientEditProfileModalComponent,

    // CLient Rule Assigmment
    ClientRuleAssignmentComponent,
    ClientRuleAssignmentCreateModalComponent,
    ClientRuleEntryModalComponent,
    ClientCreateRuleEntryModalComponent,
    ClientEditRuleEntryModalComponent,
    ClientAssignmentDeleteModalComponent,
    ClientRuleEntryDeleteModalComponent,

    // CLient Registration
    RegistrationListComponent,
    RegistrationFilterModalComponent,
    RegistrationCreateModalComponent,

    // Vendor list
    VendorListComponent,
    VendorCreateModalComponent,
    VendorEditModalComponent,
    VendorInfoModalComponent,
    ClientAssignModelComponent,

    // Logs
    VendorLogsComponent,
    VendorLogsFilterModalComponent,
    AuditLogInfoComponent,
    VendorFilterModalComponent,

    // Call Report
    CallReportComponent,
    LeadReportComponent,
    CreateLeadReportComponent,
    EditLeadReportComponent,
    LeadReportDeleteModalComponent,
    ProjectInsightComponent,
    LeadRequestComponent,
    PersonaComponent,

    //booking
    BookingsComponent,
    CreateBookingModalComponent,
    DeleteBookingModalComponent,
    BookingFilterModalComponent,
    LeadSendMiModalComponent,
    ProjectMediaPlanComponent,
    WhatsappProfileModalComponent,
    PreviewNumberModalComponent,
    ClientListProjectModalComponent,

    //whatsapp
    WhatsappRulesComponent,
    CreateWhatsappRulesComponent,
    WhatsappRuleEntryComponent,
    CreateWhatsappRuleEntryComponent,
    EditWhatsappRuleEntryComponent,


    //Sales Account

    SalesAccountComponent,
    SalesAccountCreateModalComponent,
    AssignUserComponent,
    AssignProjectComponent,


    //Call Logs

    CallLogsComponent,


    UserListModalComponent,


    CallLogsFilterModalComponent,


    ProjectAllStatusModalComponent,


    SchedulerModalComponent,


    ClientProjectCloneComponent,


    ProjectByClientComponent,


    ClientProjectWhatsappProfileDeleteComponent,


    CallerNumberModalComponent,


    ValidateLeadPhoneComponent,


    IvrCallDashboardComponent,


    PrjectWiseCallDashboardComponent,


    TelecallerWiseCallDashboardComponent,


    ClientWiseCallDashboardComponent,


    ProjectWiseCallDashboardTwoComponent,


    ExportCallRecordingComponent,


    ProjectWiseSourceDashboardComponent,


    ClientLeadFeedbackUpdateComponent,


    TasksComponent,


    FilterTaskComponent,


    EnrichFilterComponent,

    SuccessfulResetComponent,



    ResetPasswordComponent,

    SequentialCallingComponent,

   

    SaleCampaignComponent,


    CampaignDetailsComponent,
    CampaignFilterModalComponent,


    SaleCampaignCreateModalComponent,


    SaleCampaignEditModalComponent,


    SaleCampaignClientCreateModalComponent,

    AssignUserToCampaignComponent,


    CampaignLinksComponent,


    CampaignAttachmentsComponent,
    SaleCampaignProjectCreateModalComponent,
    TaskStatusRemarkModalComponent,
    CreateCampaignTaskComponent,
    CampaignCommentComponent,
    CampaignStatusComponent,
    AddLeadDeliveredComponent,
    AddAmountSpentComponent,
    AddBudgetComponent,
    LeadDeliveryListComponent,
    AmountSpentListComponent,
    BudgetListComponent,
    AddFeedbackComponent,
    FeedbackListModalComponent,
    RaiseEscalationComponent,
    EscalationStatusModalComponent,
    EscalationListComponent,
    CreateCreativeJobComponent,
    WordSortPipe,
    StrtoarrayPipe,
    EscalationFilterModalComponent,
    CreatePresalesJobComponent,
    CampaignJobLinksComponent,
    AssignUserToJobsComponent,
    CampaignJobAttachmentsComponent,
    PresalesDoneStatusComponent,
    CampaignProjectsComponent,
    AscalationCommentModalComponent,
    CreativeMasterComponent,
    CreativeMasterFilterModalComponent,
    CreativeMasterCommentModalComponent,
    PresaleJobListComponent,
    PresaleCommentModalComponent,
    PresaleMasterFilterComponent,
    ViewTaskDetailsComponent,
    AssignClientToCampaignComponent,
    CreateMarketingJobComponent,
    MarketingJobListComponent,
    MarketingJobFilterModalComponent,
    MarketingJobCommentModalComponent,
    MarketingJobFilterModalComponent,
    MarketingJobCommentModalComponent,
    ProjectListModalComponent,
    DeleteAttachmentComponent,
    DrrMasterListComponent,
    DrrFilterMasterModalComponent,
    DeleteAttachmentJobComponent,
    DeleteLinkComponent,
    DeleteLinkJobComponent,
    DeleteSpendBudgetFeebackLeaddeliveryComponent,
    CreateCampaignReviewComponent,
    CreateCampaignReviewActionItemComponent,
    UpdateCampaignReviewActionItemComponent,
    CancelledStatusModalComponent,
    ReviewMasterComponent,
    ActionItemsComponent,
    ListingPresalesProgressLogComponent,
    CreatePresalesProgressLogComponent,
    DeletePresalesLogComponent,
    AmountSpentBulkEntryComponent,
    LeadDeliveryBulkEntryComponent,
    MakeCallCloneComponent,
    CampaignReChurnsProjectsComponent,
    MediaPlanComponent,
    MediaPlanRequestCommentComponent,
    CreateMediaPlanRequestComponent,
    CreateMediaPlanComponent,
    ViewMediaPlanComponent,
    ViewMediaPlanRequestComponent,
    CancelledStatusComponent,
    EditMediaPlanRequestComponent,
    EditMediaPlanComponent,
    ClientLeadWebhookEditModalComponent,
    ClientLeadWebhookDeleteRemarkModalComponent,
    CommentMasterComponent,
    CampaignMetaComponent,
    ClientNotificationComponent,
    ClientParticipantComponent,
    EscalationResultComponent,
    EscalationActionItemComponent,
    EscalationFeedbackViewComponent,
    ViewEscalationComponent,
    CampaignReportComponent
  ],
  imports: [
    CommonModule,
    NgSelectModule,
    ClipboardModule,
    ImageCropperModule,
    MatToolbarModule,
    HighchartsChartModule,
    MatButtonModule,
    MatButtonToggleModule,
    MyDateRangePickerModule,
    MatSnackBarModule,
    MatDialogModule,
    //
    NgMultiSelectDropDownModule,
    //
    MatCardModule,
    PapaParseModule,
    MatPaginatorModule,
    MatChipsModule,
    FormsModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatBadgeModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatTableModule,
    MatSelectModule,
    MatTooltipModule,
    FlexLayoutModule,
    DragDropModule,
    MatSidenavModule,
    MatExpansionModule,
    // ChartModule.forRoot(highcharts),
    MatIconModule,
    MatListModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSlideToggleModule,
    LayoutModule,
    PageRoutingModule,
    NgSelectModule,
    MatRippleModule,
    OwlDateTimeModule,
    MatProgressSpinnerModule,
    OwlNativeDateTimeModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    CdkAccordionModule,
    WebdatarocksPivotModule,
    MatGridListModule,
    NgxMaterialTimepickerModule.forRoot(),
    QuillModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxTinymceModule.forRoot({
      baseURL: '//cdnjs.cloudflare.com/ajax/libs/tinymce/4.9.0/',
    }),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    })
  ],
  entryComponents: [
    DashboardFilterModalComponent,
    SalesAccountComponent,

    LeadListModalComponent,
    LeadListUModalComponent,
    UserCreateModalComponent,
    UserInfoModalComponent,
    UserTokenComponent,
    UserAssignProjectComponent,
    PermissionModalComponent,
    UserEditModalComponent,
    UserProfileModalComponent,
    UserFilterModalComponent,

    //whatsapp 

    WhatsappProfileModalComponent,
    PreviewNumberModalComponent,
    WhatsappRulesComponent,
    CreateWhatsappRulesComponent,
    WhatsappRuleEntryComponent,
    CreateWhatsappRuleEntryComponent,
    EditWhatsappRuleEntryComponent,

    // Permission Configuration Modals Component
    PermissionAddModalComponent,

    // Color Configuration Modals Component
    ColorCreateModalComponent,
    ColorDeleteModalComponent,
    ColorEditModalComponent,

    CampaignCreateModalComponent,

    // Color Configuration Component
    CustomizePolicyAddModalComponent,
    CustomizePolicyModalInfoComponent,

    // CLient List
    VendorAssignModelComponent,
    ClientCreateModalComponent,
    ClientEditModalComponent,
    ClientInfoModalComponent,
    ClientFilterModalComponent,
    ClientProjectInfoModalComponent,
    ClientListProjectModalComponent,

    // Client Project Modals Component
    ClientProjectCreateModalComponent,
    ClientProjectDeleteModalComponent,
    ClientProjectEditModalComponent,
    ClientProjectInfoModalComponent,
    ClientProjectBrochuerModalComponent,
    ProjectEmailNotifyModalComponent,
    ProjectUploadAvatarModalComponent,
    ClientProjectQualifiedModalComponent,
    ProjectFeedbackModalComponent,
    ProjectMediaPlanComponent,
    ProjectFilterModalComponent,
    ClientProjectStatsModalComponent,
    ProjectStatusModalComponent,
    DeleteProjectStatusModalComponent,
    ProjectByClientComponent,

    // Client lead Modals Component
    ClientMasterLeadComponent,
    ClientLeadCreateModalComponent,
    ClientLeadEditModalComponent,
    ClientLeadFilterModalComponent,
    ClientLeadInfoModalComponent,
    ClientRemarkModalComponent,
    ClientUploadModalComponent,
    ClientExportLeadModalComponent,
    ClientLeadDeleteModalComponent,
    ClientAssignLeadModalComponent,
    ClientLeadTransferModalComponent,
    ClientLeadWebhookCreateModalComponent,
    ClientLeadFailedModalComponent,
    ClientWebhookDeleteModalComponent,
    CopyLeadModalComponent,
    SetLeadColorModalComponent,
    AppointmentModalComponent,
    ConfirmLeadModalComponent,
    LeadVndorUpdatedModalComponent,
    CallsListModalComponent,
    CopyMultipleLeadModalComponent,
    AdminProjectModalComponent,
    AdminClientProjectModalComponent,
    MakeCallComponent,
    WebhookCopyComponent,
    WebhookByProjectComponent,
    LeadUpdatedToVerifiedStatusModalComponent,
    LeadDuplicateInfoComponent,
    CreateMeetingModalComponent,

    // Client Lead Profile Modals Component
    ClientLeadProfileTaskCreateModalComponent,
    ClientLeadProfileEditModalComponent,
    ClientTaskMarkDoneModalComponent,
    ClientLeadProfileNoteCreateModalComponent,
    ClientLeadProfileNoteEditModalComponent,
    ClientLeadAddressCreateModalComponent,
    ClientLeadAddressEditModalComponent,
    ClientLeadEmailCreateModalComponent,
    ClientLeadAttachmentCreateModalComponent,
    ClientTaskDeleteModalComponent,
    ClientNoteDeleteModalComponent,
    ClientAddressDeleteModalComponent,
    ClientDocumentDeleteModalComponent,
    ClientEditProfileModalComponent,
    LeadSendMiModalComponent,

    // CLient Rule
    ClientRuleAssignmentCreateModalComponent,
    ClientRuleEntryModalComponent,
    ClientCreateRuleEntryModalComponent,
    ClientEditRuleEntryModalComponent,
    ClientAssignmentDeleteModalComponent,
    ClientRuleEntryDeleteModalComponent,

    // CLient Registration
    RegistrationListComponent,
    RegistrationFilterModalComponent,
    RegistrationCreateModalComponent,


    // Vendor list
    VendorCreateModalComponent,
    VendorEditModalComponent,
    VendorInfoModalComponent,
    ClientAssignModelComponent,
    VendorFilterModalComponent,

    //logs
    VendorLogsFilterModalComponent,
    AuditLogInfoComponent,

    // Lead Report
    LeadReportDeleteModalComponent,
    ProjectInsightComponent,
    LeadRequestComponent,

    //booking
    BookingsComponent,
    CreateBookingModalComponent,
    DeleteBookingModalComponent,
    BookingFilterModalComponent,

    //sales account
    SalesAccountCreateModalComponent,
    AssignUserComponent,
    AssignProjectComponent,

    //Call Logs
    CallLogsComponent,
    CallLogsFilterModalComponent,

    //users
    UserListModalComponent,
    ProjectAllStatusModalComponent,
    SchedulerModalComponent,
    ClientProjectCloneComponent,

    //whatsapp
    ClientProjectWhatsappProfileDeleteComponent,

    CallerNumberModalComponent,

    ValidateLeadPhoneComponent,

    IvrCallDashboardComponent,


    PrjectWiseCallDashboardComponent,


    TelecallerWiseCallDashboardComponent,
//export Call Recording

ExportCallRecordingComponent,
ClientLeadFeedbackUpdateComponent,
FilterTaskComponent,
EnrichFilterComponent,
ResetPasswordComponent,
SuccessfulResetComponent,
SequentialCallingComponent,
    //export Call Recording

    ExportCallRecordingComponent,
    ClientLeadFeedbackUpdateComponent,
    FilterTaskComponent,
    EnrichFilterComponent,
    CampaignFilterModalComponent,
    SaleCampaignCreateModalComponent,
    SaleCampaignEditModalComponent,
    SaleCampaignClientCreateModalComponent,
    AddLeadDeliveredComponent,
    LeadDeliveryListComponent,
    AddAmountSpentComponent,
    AmountSpentListComponent,
    AddBudgetComponent,
    BudgetListComponent,
    AssignUserToCampaignComponent,
    CampaignLinksComponent,
    CampaignAttachmentsComponent,
    SaleCampaignProjectCreateModalComponent,
    TaskStatusRemarkModalComponent,
    CampaignStatusComponent,
    CreateCampaignTaskComponent,
    AddFeedbackComponent,
    FeedbackListModalComponent,
    RaiseEscalationComponent,
    EscalationStatusModalComponent,
    EscalationListComponent,
    CreateCreativeJobComponent,
    EscalationFilterModalComponent,
    CreatePresalesJobComponent,
    CampaignJobLinksComponent,
    AssignUserToJobsComponent,
    CampaignJobAttachmentsComponent,
    PresalesDoneStatusComponent,
    CampaignProjectsComponent,
    AscalationCommentModalComponent,
    CreativeMasterComponent,
    CreativeMasterFilterModalComponent,
    CreativeMasterCommentModalComponent,
    PresaleJobListComponent,
    PresaleCommentModalComponent,
    PresaleMasterFilterComponent,
    ViewTaskDetailsComponent,
    AssignClientToCampaignComponent,
    CreateMarketingJobComponent,
    MarketingJobListComponent,
    MarketingJobFilterModalComponent,
    MarketingJobCommentModalComponent,
    ProjectListModalComponent,
    DeleteAttachmentComponent,
    DrrMasterListComponent,
    DrrFilterMasterModalComponent,
    DeleteAttachmentJobComponent,
    DeleteLinkComponent,
    DeleteLinkJobComponent,
    DeleteSpendBudgetFeebackLeaddeliveryComponent,
    CreateCampaignReviewActionItemComponent,
    UpdateCampaignReviewActionItemComponent,
    CreateCampaignReviewComponent,
    CancelledStatusModalComponent,
    ActionItemsComponent,
    ListingPresalesProgressLogComponent,
    CreatePresalesProgressLogComponent,
    DeletePresalesLogComponent,
    AmountSpentBulkEntryComponent,
    LeadDeliveryBulkEntryComponent,
    MakeCallCloneComponent,
    CampaignReChurnsProjectsComponent,
    MediaPlanRequestCommentComponent,
    CreateMediaPlanRequestComponent,
    CreateMediaPlanComponent,
    ViewMediaPlanComponent,
    ViewMediaPlanRequestComponent,
    CancelledStatusComponent,
    EditMediaPlanRequestComponent,
    EditMediaPlanComponent,
    ClientLeadWebhookEditModalComponent,
    ClientLeadWebhookDeleteRemarkModalComponent,
    CommentMasterComponent,
    CampaignMetaComponent,
    ClientNotificationComponent,
    ClientParticipantComponent,
    EscalationResultComponent,
    EscalationActionItemComponent,
    EscalationFeedbackViewComponent,
    ViewEscalationComponent,
    CampaignReportComponent
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    DatePipe,
  ]
})
export class PagesModule { }